import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
import { Menu, X, ChevronDown } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesDropdownOpen(false);
  }, [location.pathname]);
  const servicesItems = [{
    label: 'Consulting',
    path: '/services#consulting'
  }, {
    label: 'Recruitment',
    path: '/services#recruitment'
  }, {
    label: 'Corporate Training Programmes',
    path: '/services#training'
  }, {
    label: 'Governance',
    path: '/services#governance'
  }, {
    label: 'Strategy Sessions/Corporate Retreats',
    path: '/services#strategy'
  }, {
    label: 'HR Outsourcing',
    path: '/services#hr'
  }, {
    label: 'Research',
    path: '/services#research'
  }, {
    label: 'Business Process Outsourcing',
    path: '/services#bpo'
  }];
  const navLinks = [{
    to: '/',
    label: 'Home'
  }, {
    to: '/aboutus',
    label: 'About Us'
  }, {
    to: '/academy',
    label: 'SkillzHQ Academy'
  }, {
    to: '/socialimpact',
    label: 'Social Impact'
  }, {
    to: '/projects',
    label: 'Projects'
  }, {
    to: '/contact',
    label: 'Contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-xl shadow-sm' : 'bg-transparent'}`} data-id="element-336">
      <div className="container mx-auto px-6 lg:px-8" data-id="element-337">
        <div className="flex h-20 items-center justify-between" data-id="element-338">
          <Link to="/" className="flex items-center group" data-id="element-339">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEDpYjkDJsYJX3g949itDG/logo.png" alt="SkillzHQ" className="h-8 w-auto transition-transform duration-300 group-hover:scale-105" data-id="element-340" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-341">
            {navLinks.map(link => <Link key={link.to} to={link.to} className={`text-sm font-medium transition-colors duration-200 relative group ${location.pathname === link.to ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'}`} data-id="element-342">
                {link.label}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-blue-600 transition-all duration-300 ${location.pathname === link.to ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-343" />
              </Link>)}

            {/* Services Dropdown */}
            <div className="relative" onMouseEnter={() => setServicesDropdownOpen(true)} onMouseLeave={() => setServicesDropdownOpen(false)} data-id="element-344">
              <button className={`text-sm font-medium transition-colors duration-200 flex items-center gap-1 ${location.pathname === '/services' ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'}`} data-id="element-345">
                Services
                <ChevronDown className="w-4 h-4" data-id="element-346" />
              </button>

              {servicesDropdownOpen && <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-lg shadow-xl border border-gray-100 py-2 z-50" data-id="element-347">
                  {servicesItems.map(item => <Link key={item.path} to={item.path} className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors" data-id="element-348">
                      {item.label}
                    </Link>)}
                </div>}
            </div>
          </nav>

          <div className="flex items-center gap-4" data-id="element-349">
            <Button variant="primary" size="sm" onClick={() => navigate('/academy')} className="hidden sm:block" data-id="element-350">
              Get Started
            </Button>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 text-gray-700 hover:text-blue-600 transition-colors" aria-label="Toggle menu" data-id="element-351">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-352" /> : <Menu className="w-6 h-6" data-id="element-353" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="lg:hidden absolute top-20 left-0 right-0 bg-white/95 backdrop-blur-xl shadow-lg border-t border-gray-100" data-id="element-354">
            <nav className="container mx-auto px-6 py-6" data-id="element-355">
              <div className="flex flex-col space-y-4" data-id="element-356">
                {navLinks.map(link => <Link key={link.to} to={link.to} className={`text-base font-medium py-2 transition-colors duration-200 ${location.pathname === link.to ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'}`} data-id="element-357">
                    {link.label}
                  </Link>)}

                {/* Mobile Services Accordion */}
                <div data-id="element-358">
                  <button onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)} className="text-base font-medium py-2 text-gray-700 hover:text-blue-600 flex items-center justify-between w-full" data-id="element-359">
                    Services
                    <ChevronDown className={`w-4 h-4 transition-transform ${servicesDropdownOpen ? 'rotate-180' : ''}`} data-id="element-360" />
                  </button>
                  {servicesDropdownOpen && <div className="pl-4 mt-2 space-y-2" data-id="element-361">
                      {servicesItems.map(item => <Link key={item.path} to={item.path} className="block py-2 text-sm text-gray-600 hover:text-blue-600" data-id="element-362">
                          {item.label}
                        </Link>)}
                    </div>}
                </div>

                <Button variant="primary" size="sm" onClick={() => {
              navigate('/academy');
              setMobileMenuOpen(false);
            }} className="w-full mt-4" data-id="element-363">
                  Get Started
                </Button>
              </div>
            </nav>
          </div>}
      </div>
    </header>;
}